import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import ZoneDefinitionForm from 'Services/ProductManagement/Features/ZoneDefinition/Components/ZoneDefinitionForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function ZoneDefinitionCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/zone-definitions`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Zone definitions`,
      link: baseUrl
    },
    {
      title: t`Create new zone definition`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new zone definition`}</PageTitle>
        </Grid>
      </Grid>
      <ZoneDefinitionForm successBaseUrl={previousLocation} />
    </Box>
  )
}
